import script from "./RouteSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteSelector.vue?vue&type=script&setup=true&lang=js"

import "./RouteSelector.vue?vue&type=style&index=0&id=fe0a7db0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe0a7db0"]])

export default __exports__